import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { headerBannerServices } from "../services/headerbannerServices";

// Async thunk to fetch banners
export const fetchBanners = createAsyncThunk(
  "banners/fetchBanners",
  async (lang, { rejectWithValue }) => {
    try {
      const response = await headerBannerServices(lang);
      return response.data.data.records; // Assuming the data is in response.data
    } catch (error) {
      return rejectWithValue(error.message); // Handle errors
    }
  }
);

// Define the initial state
const initialState = {
  banners: [],
  loading: false,
  error: null,
};

// Create slice
const headerBannerSlice = createSlice({
  name: "banners",
  initialState,
  reducers: {}, // You can add other reducers here if needed
  extraReducers: (builder) => {
    builder
      .addCase(fetchBanners.pending, (state) => {
        state.loading = true; // Set loading to true when API call is in progress
        state.error = null; // Reset error
      })
      .addCase(fetchBanners.fulfilled, (state, action) => {
        state.loading = false;
        state.banners = action.payload; // Store banners data in the state
      })
      .addCase(fetchBanners.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload; // Set error message in case of failure
      });
  },
});

// Export the reducer to be used in the store
export default headerBannerSlice.reducer;
